<template>
    <div class="mx-auto" style="margin-bottom:51px !important;
    overflow: scroll;    margin-top: -11px; text-align:justify;">
      <v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
  <loading :active.sync="isLoading"  :is-full-page="fullPage"></loading>
    <div v-if="uName">
      
      <v-container v-show="sendaddressshowApi">
        <v-col cols="12" sm="6" md="3"  style="text-align: center;color:#000;border-bottom:solid 1px #000">
          <b><v-icon>mdi-truck-delivery</v-icon> &nbsp; Previous Delivery Address(s)</b>
        </v-col>
        <v-row>
           <v-col cols="12" sm="6" md="3"  style="     font-size: 3.2vw;   text-align: left;border-bottom:solid 1px rgba(0, 0, 0, 0.22);" v-for="(item1,i) in sendaddress1" :key="i" >
         <b-form-group :label="item1.CustomerName" class="radio" style="margin-bottom: 0rem;">
          <v-row>
         <v-col cols="9" >
           <b-form-radio v-model="oldAddress" name="some-radios" :value="item1.CustomerId">{{item1.HouseNo +' '+item1.Area+' '+item1.City+' '+item1.AddressType+' '+item1.PINcode+' '+item1.Phone}}
           </b-form-radio>
           </v-col>
           <v-col cols="3" >
          
            <span @click="edit(i)" style="paddind:5px;margin-left: 10px;"><v-icon style="    color: teal;">mdi-grease-pencil</v-icon>
           </span>
           <span @click="dlt(i)" style="paddind:5px;margin-left: 12px;"><v-icon style="    color: brown;">mdi-delete</v-icon>
           </span>
          
           </v-col>
            </v-row>
         </b-form-group>
           </v-col>


        </v-row>
         <v-col cols="12" sm="6" md="3">
         
          <b-button  variant="success" size="sm" @click="postCustomerwithPre">Proceed</b-button>
        </v-col>
      </v-container>
    </div>
    <div v-else>
      <v-container v-show="sendaddressshow">
        <v-col cols="12" sm="6" md="3"  style="text-align: center;color:#000;border-bottom:solid 1px #000">
          <b><v-icon>mdi-truck-delivery</v-icon> &nbsp; Previous Delivery Address(s)</b>
        </v-col>
        <v-row>
           <v-col cols="12" sm="6" md="3"  style="     font-size: 3.2vw;   text-align: left;border-bottom:solid 1px rgba(0, 0, 0, 0.22);" v-for="(item1,i) in sendaddress" :key="i" >
         <b-form-group :label="item1.customerName" class="radio">
           <b-form-radio v-model="oldAddress" name="some-radios" :value="item1.cid">{{item1.houseNo +' '+item1.area+' '+item1.city+' '+item1.addressType+' '+item1.piNcode+' '+item1.phone}}<span class="pull-right"> <span @click="edit(i)" style="paddind:5px;margin-left: 10px;"><v-icon style="    color: teal;">mdi-grease-pencil</v-icon></span><span @click="dlt(i)" style="paddind:5px;margin-left: 12px;"><v-icon style="    color: brown;">mdi-delete</v-icon></span></span></b-form-radio>
            
         </b-form-group>
           </v-col>


        </v-row>
         <v-col cols="12" sm="6" md="3">
         
          <b-button  variant="success" size="sm" @click="postCustomerwithPre">Proceed</b-button>
        </v-col>
      </v-container>
    </div>

      <v-expansion-panels >
    <v-expansion-panel class="text-center mx-auto" > 
      <v-expansion-panel-header style="background-color: #6c757d57;" expand-icon="mdi-menu-down" >Add New Address</v-expansion-panel-header>
      <v-expansion-panel-content>
                <v-container>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.name" size="sm" placeholder="Name*" autofocus ></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.mob" type="number" size="sm" placeholder="Mobile No*" focus minlength="10" maxlength="12"></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.amob" type="number" size="sm" placeholder="Phone No" focus minlength="10" maxlength="12"></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.mailid" type="email" size="sm" placeholder="Email Id" focus></b-form-input>
        </v-col>

        <v-col cols="12" sm="6" md="3">
    <b-form-textarea
    size="sm" 
      id="textarea"
      v-model="customer.address"
      placeholder="House No.,Building name*"
      rows="3"
      max-rows="6"
    ></b-form-textarea>

   </v-col>
    <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.landmark" size="sm" placeholder="Landmark*" autofocus ></b-form-input>
        </v-col>
         <v-col cols="6" sm="6" md="3">
          <b-form-input v-model="customer.town" type="text" size="sm" placeholder="City/District/Town*" class="input" focus></b-form-input>
        </v-col>
        <v-col cols="6" sm="6" md="3">
          <b-form-input v-model="customer.state" type="text" size="sm" placeholder="State*" class="input" focus></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.pin" type="number" size="sm" placeholder="Pincode*" focus></b-form-input>
        </v-col>
          <v-col cols="12" sm="6" md="3"  style="    text-align: left;">
         <b-form-group label="Address Type :" class="radio">
      <b-form-radio v-model="customer.addresstype" name="some-radios" value="Home">Home (All day delivery)</b-form-radio>
      <b-form-radio v-model="customer.addresstype" name="some-radios" value="Work">Work (Delivery between 10 AM-5 PM)</b-form-radio>
    </b-form-group >
       </v-col>
   <!-- <gmap-map ref="mymap" :center="{lat: 10.8505159, lng: 76.2710833}" :zoom="17" style="width: 100%; height: 300px">
        <gmap-marker :position="customer.geoLocation" :draggable="true" @drag="updateCoordinates" />
    </gmap-map> -->
 <v-col cols="12" >
   <label class="text-left" style="width:100%"> Pick your location</label>
    <GmapMap :center="{lat:latitude, lng:longitude}" :zoom="16" map-type-id="terrain" style="width: 100%; height: 300px">
      <GmapMarker  :position="{lat:latitude, lng:longitude}" :draggable="true" @drag="updateCoordinates"  />
    </GmapMap>
 </v-col>

        <v-col cols="12" sm="6" md="3">
          <b-button variant="danger" size="sm">Cancel</b-button>&nbsp;
          <b-button  variant="success" size="sm" @click="postCustomer">Proceed</b-button>
        </v-col>
      </v-row>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

  
      
    </div>
</template>

<script>
import Vue from 'vue'
 import axios from 'axios';
import Router from '../router';
 import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as VueGoogleMaps from 'vue2-google-maps'

export default {
  components: {
            Loading
        },
        
  data () {
    return {
       isLoading: false,
       fullPage: true,
      sendaddressshow:'',
      sendaddressshowApi:'',
      title:'Customer Details',
      address:[],
      oldAddress:'',
      customer:{
          name:'',
          mob:'',
          amob:'',
          mailid:'',
          address:'',
          landmark:'',
          orderitems:[],
          pin:'',
          town:'',
          state:'',
          addresstype:'',
          createdDate:'',
          remarks:'',
          geoLocation:''
         

      },
      coordinates:'',
      sendaddress:[],
       snackbar: {
                show: false,
                message: null,
                color: null
            },
       senddata:[],
       orderresultdata:[],
       orderarray:[],
       uName:'',
       sendaddress1:[],
       editdataarr:[],
       latitude:'',
       longitude:''
    
    }
  },
  created() {
                setInterval(this.getNow, 1000);
   
 
            },
  mounted(){

    
    /////////////////////////////////////////////////////////

    navigator.geolocation.getCurrentPosition(pos => {
       this.customer.geoLocation = pos.coords.latitude+","+pos.coords.longitude
        this.latitude = pos.coords.latitude
        this.longitude = pos.coords.longitude
        console.log("lati "+pos.coords.latitude)
        console.log("long "+pos.coords.longitude)
     
    }, err => {
     
      console.log("error "+err)
    })



    ////////////////////////////////////////////////////////////
          if (localStorage.getItem("islogedIn") !== null) {

            if(localStorage.getItem("Address1") !== null)
            {
                this.sendaddressshowApi = true
            }
                  this.sendaddressshow = false
                 this.uName = localStorage.getItem("logeduserId")
                 
                   
                  this.getaddreddfromApi()
            }else
            {
               this.uName = ''
               if(localStorage.getItem("Address") !== null)
            {
                  this.sendaddressshow = true
            }
                 this.sendaddress = JSON.parse(localStorage.getItem("Address"))
         
             this.sendaddressshowApi = false
            }
           
            
    
    this.$parent.$children[0].$parent.ttlval = this.title
    this.senddata = JSON.parse(localStorage.getItem("sendatta"));
       if (localStorage.getItem("Address") === null) {
           this.sendaddressshow = false
       }else{
            this.sendaddress = JSON.parse(localStorage.getItem("Address"))
            this.sendaddressshow = true
           
       }
   
  },
  methods:{

    updateCoordinates(location) {
      this.customer.geoLocation = location.latLng.lat()+","+location.latLng.lng()
            this.coordinates = {
                lat: location.latLng.lat(),
                lng: location.latLng.lng(),
            };
        },
   
    ///////////////////////////////////////////////////
     getPosition(position) {
  console.log(position.coords.latitude, position.coords.longitude);
},

    
    edit(pos){
       if (localStorage.getItem("islogedIn") !== null) {
          this.editdataarr = JSON.parse(localStorage.getItem("Address1"))
      // console.log(JSON.stringify(this.editdataarr[pos]))
      
       localStorage.setItem("editpos",pos)
       localStorage.setItem("editableaddress",JSON.stringify(this.editdataarr[pos]))
        Router.push('/editaddress');
       }else{
          //guest user
      this.editdataarr = JSON.parse(localStorage.getItem("Address"))
      // console.log(JSON.stringify(this.editdataarr[pos]))
       localStorage.setItem("editpos",pos)
       localStorage.setItem("editableaddress",JSON.stringify(this.editdataarr[pos]))
        Router.push('/editaddress');
       }
      
    
      //guest user
    },
    dlt(pos){
      if (localStorage.getItem("islogedIn") !== null) {

       this.editdataarr = JSON.parse(localStorage.getItem("Address1"))
      //  console.log(this.editdataarr[pos].CustomerId)
       this.isLoading = true;
       //-------------------------

         axios.delete(this.$bURL+"onlinecustomer/"+this.editdataarr[pos].CustomerId)
              .then((response)  =>  {
                this.editdataarr.splice(pos,1); 
                localStorage.setItem("Address1",JSON.stringify(this.editdataarr))
                this.sendaddress1 = JSON.parse(localStorage.getItem("Address1"))
                // console.log(response.data.length)
                  
                  this.isLoading = false;
                  this.snackbar = {
                        message: "Deleted successfully.",
                        color: 'success',
                        show: true
                    }
              }, (error)  =>  {
                this.snackbar = {
                        message: "Somethign went wrong.",
                        color: 'danger',
                        show: true
                    }
                    this.isLoading = false;
                  console.log(error)
         })


       //---------------------------
      }else{
       this.editdataarr = JSON.parse(localStorage.getItem("Address"))
       this.editdataarr.splice(pos,1); 
       localStorage.setItem("Address",JSON.stringify(this.editdataarr))
       this.sendaddress = JSON.parse(localStorage.getItem("Address"))
      }
      
      
      //  console.log(pos)
    },
    confirmdlt(pos)
    {
      console.log(pos)
    },
    getaddreddfromApi(){
          //  axios.get(this.$bURL+"onlinecustomer/GetDeliveryAddresses?Username="+this.uName)
           axios.get(this.$bURL+"registeredcustomer/GetDeliveryAddresses?Username="+this.uName)
              .then((response)  =>  {
                   console.log(response.data.length)
                    if(response.data.length > 0){
                   localStorage.setItem("Address1",JSON.stringify(response.data))
                   this.sendaddress1 = JSON.parse(localStorage.getItem("Address1"))
                     this.sendaddressshowApi = true
                    }
                  //  this.sendaddress = response.data
              }, (error)  =>  {
                  console.log(error)
             })
    },
    //----------------------------------------------
    getNow: function() {
                    const today = new Date();
                    const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    const dateTime = date +' '+ time;
                    this.customer.createdDate = dateTime;
                },
    postCustomer(){

    if(!this.customer.name)
    {
             this.snackbar = {
                        message: "Please fill in the  Name field.",
                        color: 'success',
                        show: true
                    }
    }else if(!this.customer.mob){
      this.snackbar = {
                        message: "Please fill in the  Mobile field.",
                        color: 'success',
                        show: true
                    }
    }
    else if(!this.customer.town){
      this.snackbar = {
                        message: "Please fill in the  Address field.",
                        color: 'success',
                        show: true
                    }
    }
    else if(!this.customer.addresstype){
      this.snackbar = {
                        message: "Please choose your Address Type: Home or Work",
                        color: 'success',
                        show: true
                    }
    }
    
    else{



  this.isLoading = true;
      this.cusobj =
        {
	
	"customerName": this.customer.name,
	"mobile": this.customer.mob,
	"phone": this.customer.amob,
	"email": this.customer.mailid,
	"houseNo": this.customer.address,
	"area": this.customer.landmark,
	"city": this.customer.town,
	"state": this.customer.state,
	"piNcode": this.customer.pin,
	"remarks": this.customer.remarks,
	"addressType": this.customer.addresstype,
	"geoLocation": this.customer.geoLocation,
	"username":  this.uName

      }
       //localStorage.setItem("this.cusobj",JSON.stringify(this.cusobj));
      axios.post(this.$bURL+"OnlineCustomer",this.cusobj)
      .then((response)  =>  {
       console.log(response.data)
       this.senddata[0].CustomerId = response.data;
       this.cusobj.cid = response.data;
      //  this.address.push(JSON.stringify(this.cusobj))


      if (localStorage.getItem("Address") === null) {
        this.address.push(this.cusobj)
      
       localStorage.setItem("Address",JSON.stringify(this.address))
       }else{
            this.address = JSON.parse(localStorage.getItem("Address"))
            this.address.push(this.cusobj)
            localStorage.setItem("Address",JSON.stringify(this.address))
       }


      //  localStorage.setItem("Address", JSON.stringify(this.address));
          this.postorder()
      }, (error)  =>  {
          console.log(error)
          this.snackbar = {
                        message: error,
                        color: 'danger',
                        show: true
                    }
                    this.isLoading = false
      })

    }
      
    },

    postCustomerwithPre(){
      if(!this.oldAddress)
      {
        
           this.snackbar = {
                        message: 'Please Choose an Address...',
                        color: 'danger',
                        show: true
                    }
      }else{
        
          this.isLoading = true;
          this.senddata[0].CustomerId = this.oldAddress
           console.log(this.oldAddress)
           this.postorder()
      }
      
    },
    postorder()
    {
      
      axios.post(this.$bURL+"OnlineOrder",this.senddata[0])
      .then((response)  =>  {
         this.snackbar = {
                        message: 'Order Placed Successfully..',
                        color: 'success',
                        show: true
                    }
       console.log(response.data)
      //  console.log(re)
      //  this.orderdataobj = response.data,
      //  this.orderdata.push(this.orderdataobj)
      
      if (localStorage.getItem("orderdetails") === null) {
  //... console.log("sss")
       this.orderresultdata.push(response.data);
       localStorage.setItem("orderdetails",JSON.stringify(this.orderresultdata))
       }else{
          this.orderresultdata = JSON.parse(localStorage.getItem("orderdetails"))
           this.orderresultdata.push(response.data);
       localStorage.setItem("orderdetails",JSON.stringify(this.orderresultdata))
       }
      
      
    
       this.$parent.$children[0].$parent.itemcountnumber = ''
           window.localStorage.removeItem("cartlistarray");
           window.localStorage.removeItem("cartlist");
           window.localStorage.removeItem("cartcount");
           window.localStorage.removeItem("carclicked");
           
          
       
                  this.isLoading = false
                   Router.push('/account');
         
           
      }, (error)  =>  {
          console.log(error)
      })
    }
  }
}
</script>
<style scoped>
.v-text-field__slot[data-v-40cefe54] input {
   text-align: left !important;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>